import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import { useState } from "react";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-cream-200 text-foreground border-t border-border/30">
      {/* Statement Section */}
      <div className="py-20 md:py-32 px-6 md:px-12 text-center">
        <div className="max-w-5xl mx-auto">
          <p className="text-xl md:text-2xl text-foreground/80 font-semibold tracking-[0.2em] mb-1 uppercase">EN</p>
          <h2 className="text-7xl md:text-9xl lg:text-[11rem] font-black text-foreground leading-[0.8] tracking-tighter uppercase">
            FRISKARE
          </h2>
          <p className="text-2xl md:text-3xl text-foreground/80 font-semibold -mt-1 md:-mt-2 uppercase">ARBETSPLATS</p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 py-5">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Links */}
          <nav className="flex flex-wrap items-center gap-x-5 gap-y-1">
            <Link to="/kontakt" className="text-xs text-muted-foreground hover:text-foreground transition-colors">KONTAKT</Link>
            <Link to="/terms" className="text-xs text-muted-foreground hover:text-foreground transition-colors">VILLKOR</Link>
            <Link to="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">INTEGRITETSPOLICY</Link>
          </nav>

          {/* Newsletter */}
          <form onSubmit={handleSubscribe} className="flex items-center gap-2 shrink-0">
            <span className="text-xs text-muted-foreground whitespace-nowrap">
              {subscribed ? "Tack!" : "PRENUMERERA PÅ NYHETSBREV"}
            </span>
            {!subscribed && (
              <>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-post"
                  className="w-32 px-2 py-1 bg-transparent border-b border-muted-foreground/40 text-xs text-foreground placeholder:text-muted-foreground/50 focus:outline-none focus:border-foreground transition-colors"
                />
                <button type="submit" className="text-xs text-foreground hover:underline">→</button>
              </>
            )}
          </form>

          {/* Social */}
          <div className="flex items-center gap-4">
            <div className="flex gap-3">
              <a href="https://instagram.com/drinkaquadias" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-muted-foreground hover:text-foreground transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href="https://linkedin.com/company/aquadias" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-muted-foreground hover:text-foreground transition-colors"><Linkedin className="w-4 h-4" /></a>
            </div>
          </div>
        </div>
        <div className="mt-4 pt-4 border-t border-border/30 text-center">
          <p className="text-[10px] text-muted-foreground">info@aquadias.se · 070-760 27 70 · Zenitvägen 67, 175 65 Järfälla</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
